/**
 * BoostAI検索モーダルとテーマ検索モーダルの連携
 * BoostAIの閉じるボタン(.boost-sd__button-text-x)クリック時に、テーマのsearch-modalも閉じる
 */
(function () {
  'use strict';

  document.addEventListener('click', (e) => {
    if (e.target.closest('.boost-sd__button-text-x')) {
      const searchModal = document.querySelector('search-modal#search-modal');
      if (searchModal && typeof searchModal.close === 'function') {
        searchModal.close();
      }
    }
  });
})();
